import { createAction } from '@reduxjs/toolkit';

export const loadingChanged = createAction('EXPERT_DIRECTORY/LOADING_CHANGED', (payload: boolean) => ({ payload }));
